/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiCostcentersQueryParamsSchema = z.object({
  Filters: z.string().optional(),
  SortOrder: z.string().optional(),
  PageNumber: z.coerce.number().int(),
  PageSize: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiCostcenters200Schema = z.object({
  items: z.array(
    z.object({
      id: z.coerce.number().int().optional(),
      name: z.coerce.string(),
      client: z.object({
        value: z.coerce.number().int(),
        label: z.coerce.string(),
      }),
      isVisible: z.boolean(),
    }),
  ),
  pageNumber: z.coerce.number().int(),
  totalPages: z.coerce.number().int().optional(),
  pageSize: z.coerce.number().int(),
  currentPageSize: z.coerce.number().int().optional(),
  currentStartIndex: z.coerce.number().int().optional(),
  currentEndIndex: z.coerce.number().int().optional(),
  totalCount: z.coerce.number().int().optional(),
  hasPrevious: z.boolean().optional(),
  hasNext: z.boolean().optional(),
  nextPageNumber: z.coerce.number().int().nullable().nullish(),
});

export const getApiCostcentersQueryResponseSchema = z.lazy(
  () => getApiCostcenters200Schema,
);
